import { Link } from "react-router-dom";

const Header = (props) => {
  const {
    children,
    style,
    logoSrc,
    logoAlt,
    qa,
  } = props;

  return <header className="o-header" style={style} data-qa={qa}>
    <Link to={"/"} className="o-header__logo">
      <img src={logoSrc} alt={logoAlt} />
    </Link>
    {children}
  </header>
}

export default Header;
